import {Tooltip} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React, {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {
    closeAllActionPanel,
    globalActionPanelOpen,
    globalActionPanelPinned,
    setActionPanelOpen,
    setActionPanelPosition,
} from '../../store/reducers/globalModal';
import clsx from 'clsx';
import {useHeaderIconStyles} from '../patient/components/iconStyle';

const ActionPanelButton = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const classes = useHeaderIconStyles();

    const buttonRef = useRef(null);
    const isOpen = useSelector(globalActionPanelOpen);
    const isPinnedOpen = useSelector(globalActionPanelPinned);
    const isSomeOpen = isOpen || isPinnedOpen !== 'none';

    const handleClick = () => {
        const button = buttonRef.current.getBoundingClientRect();
        const position = {x: button.left, y: button.bottom};
        dispatch(setActionPanelPosition(position));
        if (isSomeOpen) {
            dispatch(closeAllActionPanel());
        } else {
            dispatch(setActionPanelOpen(true));
        }
    };

    return (
        <Tooltip title={t('More options')}>
            <IconButton
                ref={buttonRef}
                size="small"
                onClick={handleClick}
                color={(isSomeOpen) ? 'primary' : 'default'}
                className={clsx(classes.iconHover, (isSomeOpen) && classes.iconButton)}
            >
                <MoreVertIcon/>
            </IconButton>
        </Tooltip>
    );
};

export default ActionPanelButton;